/**
 * Colours enum
 * @enum {string} ColourEnum - The colours enum.
 * @property {string} yellow - The yellow colour.
 * @property {string} mint - The mint colour.
 * @property {string} cream - The cream colour.
 * @property {string} navy - The navy colour.
 * @property {string} sky - The sky colour.
 * @property {string} red - The red colour.
 * @property {string} gray - The gray colour.
 */
export enum ColourEnum {
  yellow = "bg-brand-500",
  mint = "bg-mint-500",
  cream = "bg-cream-100",
  navy = "bg-navy-500",
  sky = "bg-sky-500",
  red = "bg-red-500",
  gray = "bg-gray-500",
}
